import { fromUTC } from 'helpers/dates';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router';
import Topics from './Topics';
import Status from './Status';
import { UserContext } from './List';

function IssueItem({ issue, handleChangeIssue, index }) {
    const user = useContext(UserContext);
    const [isMine, setIsMine] = useState(false);

    useEffect(() => {
        if (
            issue.status === 'new' ||
                (issue.statusBy && user.email === issue.statusBy.email) || 
                !issue.statusBy
        ) {
            setIsMine(true);
        } else {
            setIsMine(false);
        }
    }, [issue]);

    /**
     * @param {string} status 
     */
    const handleChangeStatus = (status) => {
        handleChangeIssue(index, { status, _id: issue._id });
    };

    return (
        <li 
            className={
                `issues-list-item ${!isMine ? 'isNotMine' : ''}`
            }
        >
            <div className='column'>
                <div className='inner-item'>
                    <span className='title'>TOPICS:</span> <Topics topics={issue.topics} />
                </div>
                <div className='inner-item'>
                    <span className='title'>REPORTER:</span> { issue.addedBy.email }
                </div>
                <div className='inner-item'>
                    <span className='title'>DATE:</span> { fromUTC(issue.addedAt).toLocaleString() }
                </div>
            </div>

            <div className='column'>
                <div className='inner-item'>
                    <span className='title'>refNo: {issue.refNo}</span> 
                </div>
                <div className='inner-item'>
                    <span className='title'>STATUS:</span> 
                    <Status 
                        status={issue.status}
                        handleChangeStatus={handleChangeStatus} 
                    />
                </div>
                <div className='inner-item'>
                    <span className='title'>UPDATED:</span>  
                    { issue.statusAt ? new Date(issue.statusAt).toLocaleString() : null }
                </div>
                <div className='inner-item'>
                    <span className='title'>BY USER:</span>  
                    { issue.statusBy ? issue.statusBy.email : null }
                </div>
            </div>

            <div className='column'>
                <Link to={issue._id} target='_blank'>OPEN</Link>
            </div>
        </li>
    );
}

export default React.memo(IssueItem);



// WEBPACK FOOTER //
// ./app/components/Issues/List/IssueItem.jsx